import React, { useEffect } from "react";
import { Copy, ClipboardPaste, CopyPlus, Scissors, Trash2, BringToFront, SendToBack, ImageDown, ClipboardCopy, Crop } from "lucide-react";

// Right-click menu on the page (Publisher-style).
export function ContextMenu({ at, hasSel, isImage, canPaste, onAction, onClose }) {
  useEffect(() => {
    const k = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", k); window.addEventListener("resize", onClose);
    return () => { window.removeEventListener("keydown", k); window.removeEventListener("resize", onClose); };
  }, [onClose]);
  const items = [
    ...(isImage ? [["crop", "Crop…", Crop, ""], ["sep"]] : []),
    ...(hasSel ? [["copy", "Copy", Copy, "Ctrl+C"], ["cut", "Cut", Scissors, ""], ["duplicate", "Duplicate", CopyPlus, "Ctrl+D"]] : []),
    ["paste", "Paste", ClipboardPaste, "Ctrl+V", !canPaste],
    ...(hasSel ? [["sep"], ["copypic", "Copy as Picture", ClipboardCopy, ""], ["saveas", "Save as Picture…", ImageDown, ""], ["sep"], ["front", "Bring to Front", BringToFront, ""], ["back", "Send to Back", SendToBack, ""], ["sep"], ["delete", "Delete", Trash2, "Del"]] : []),
  ];
  const left = Math.min(at.x, window.innerWidth - 210), top = Math.min(at.y, window.innerHeight - items.length * 32 - 10);
  return (
    <div className="fixed inset-0 z-50" data-outside-close onMouseDown={onClose} onContextMenu={(e) => { e.preventDefault(); onClose(); }} data-testid="ds-context-overlay">
      <div className="absolute w-[200px] bg-white rounded-md shadow-2xl border border-slate-200 py-1 text-[13px]" style={{ left, top }} onMouseDown={(e) => e.stopPropagation()} data-testid="ds-context-menu">
        {items.map(([k, label, I, keys, off], i) => k === "sep" ? <div key={`s${i}`} className="h-px bg-slate-200 my-1" /> : (
          <button key={k} disabled={off} onClick={() => { onClose(); onAction(k); }} data-testid={`ds-ctx-${k}`}
            className={`w-full flex items-center gap-2 px-3 py-1.5 text-left transition-colors disabled:opacity-40 ${k === "delete" ? "text-red-600 hover:bg-red-50" : "hover:bg-sky-50"}`}>
            <I className="h-4 w-4" /><span className="flex-1">{label}</span><span className="text-[10px] text-slate-400">{keys}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
